import { TabList, TabPanel } from '@mui/lab';
import { Box, Button, Tab } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const TableContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'end',
  width: '100%',
  backgroundColor: '#FFFFFE',
  boxShadow: '0px 1px 2px #61335429',
  padding: '32px',
}));

export const FinancialBox = styled(Box)(() => ({
  border: '1px solid #ADADAD66',
  borderRadius: '10px',
  backgroundColor: '#FFFFFE',
  padding: '12px 24px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
}));

export const PaymentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  padding: '20px',
  backgroundColor: alpha(theme.palette.primary.light, 0.05),
  border: '1px solid',
  borderColor: alpha(theme.palette.primary.light, 0.5),
  borderRadius: '12px',
  margin: '20px 0',
}));

interface ActionButtonProps {
  bgcolor: string;
  textcolor: string;
}

export const ActionButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'bgcolor' && prop !== 'textcolor',
})<ActionButtonProps>(({ bgcolor, textcolor }) => ({
  width: '102px',
  height: '36px',
  fontSize: '14px',
  backgroundColor: bgcolor,
  color: textcolor,
  borderRadius: 12,
  '&:hover': {
    backgroundColor: bgcolor,
    filter: 'brightness(80%)',
  },
}));

export const DisabledActionButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'bgcolor' && prop !== 'textcolor',
})<ActionButtonProps>(({ bgcolor, textcolor }) => ({
  width: '102px',
  height: '36px',
  fontSize: '14px',
  backgroundColor: bgcolor,
  color: textcolor,
  borderRadius: 12,
  '&.Mui-disabled': {
    backgroundColor: bgcolor,
    color: textcolor,
    cursor: 'not-allowed',
    opacity: 1,
    filter: 'none',
  },
}));

export const StyledTabPanel = styled(TabPanel)(() => ({
  minHeight: '400px',
  width: '100%',
  marginTop: 24,
  padding: 0,
}));

export const StyledTabList = styled(TabList)(({ theme }) => ({
  '& .MuiTabs-indicator': {
    color: theme.palette.primary.dark,
  },
  '& .MuiTab-root.Mui-selected': {
    color: theme.palette.primary.dark,
  },
}));

export const TabStyled = styled(Tab)(() => ({
  textTransform: 'capitalize',
  fontSize: 16,
  fontWeight: 500,
  color: '#707070',
  padding: '14px 16px',
  borderRadius: '20px 20px 0 0',
  '&.Mui-selected': {
    backgroundColor: '#FFFFFE',
    boxShadow: '0px 1px 2px #61335429',
  },
}));

export const TabNotification = styled(Box)(() => ({
  width: 8,
  height: 8,
  bgcolor: '#FF4444',
  borderRadius: '50%',
}));
